/*
 * This file is generated by icons/template.js
 */
const SvgTalk = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 20 20" {...props}>
		<path
			fill="#707070"
			fillRule="evenodd"
			d="M10 0C4.66 0 0 3.366 0 7.88c0 2.087 1.021 3.95 2.624 5.327l-1.037 2.987a.714.714 0 0 0 .951.893l3.908-1.639c1.181 2.094 3.658 3.482 6.411 3.482.782 0 1.536-.11 2.243-.314l2.811 1.317a.714.714 0 0 0 .985-.86l-.697-2.241C19.307 15.74 20 14.289 20 12.679c0-.824-.178-1.603-.5-2.312.324-.775.5-1.61.5-2.488C20 3.366 15.34 0 10 0M1.429 7.88c0-3.402 3.654-6.451 8.571-6.451s8.571 3.049 8.571 6.45-3.654 6.45-8.571 6.45c-1.1 0-2.15-.156-3.114-.44a.7.7 0 0 0-.479.026L3.462 15.15l.676-1.948a.71.71 0 0 0-.24-.802c-1.561-1.194-2.47-2.8-2.47-4.522"
			clipRule="evenodd"
		/>
		<path
			fill="#707070"
			fillRule="evenodd"
			d="M5 6.429c0-.395.32-.715.714-.715h8.572a.714.714 0 1 1 0 1.429H5.714A.714.714 0 0 1 5 6.429M5 9.286c0-.395.32-.715.714-.715H10A.714.714 0 1 1 10 10H5.714A.714.714 0 0 1 5 9.286"
			clipRule="evenodd"
		/>
	</svg>
);
SvgTalk.displayName = 'iconTalk';
export default SvgTalk;
